import { createContext, useState } from "react";
import GlobalLoader from "../components/GlobalLoader";

export const loaderContext = createContext();

export const LoaderProvider = ({ children }) => {
    const [isloading, setIsLoading] = useState(false);

    return (
        <>
            <loaderContext.Provider value={{ isloading, setIsLoading }}>
                {isloading && <GlobalLoader />}
                {children}
            </loaderContext.Provider>
        </>
    )
}